import { Table } from "@shared/ui";
import { ArrowRight } from "lucide-react";
import {
  CreatorRosterIdentity,
  FollowerCount,
  creatorRosterScroll,
} from "../CreatorRosterAdd";
import rosterStyles from "../CreatorRosterAdd/styles.module.scss";
import { ScriptCreator } from "./types";

export function ScriptCreatorTable({
  creators,
  onOpen,
}: {
  creators: ScriptCreator[];
  onOpen: (id: string) => void;
}) {
  return (
    <Table<ScriptCreator>
      wrapperClassName={rosterStyles.tableWrap}
      pagination={false}
      scroll={creatorRosterScroll}
      size="small"
      rowKey="id"
      dataSource={creators}
      onRow={(creator) => ({
        className: rosterStyles.clickableRow,
        onClick: () => onOpen(creator.id),
      })}
      columns={[
        {
          title: "Creator",
          key: "creator",
          render: (_, creator) => (
            <CreatorRosterIdentity
              name={creator.name}
              image={creator.image}
              platform={creator.platform}
              username={creator.username}
            />
          ),
        },
        {
          title: "Followers",
          key: "followers",
          render: (_, creator) => <FollowerCount count={creator.followers} />,
        },
        {
          title: "",
          key: "open",
          align: "right",
          width: 148,
          render: () => (
            <span className={rosterStyles.rowAction}>
              Generate script
              <ArrowRight size={14} />
            </span>
          ),
        },
      ]}
    />
  );
}
